import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationAR from "./locales/ar.json";
import translationEN from "./locales/en.json";

const resources = {
  ar: {
    translation: translationAR,
  },
  en: {
    translation: translationEN,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    lng: localStorage.getItem("i18nextLng") || "ar", // Default to Arabic if no language is stored
    fallbackLng: "ar", // Fallback to Arabic
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ["localStorage", "navigator"], // Prioritize localStorage, then browser settings
      caches: ["localStorage"], // Cache language in localStorage
    },
  });

// Dynamically update the page direction and language
const setPageDirection = (lng) => {
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lng;
};

// Set the direction on page load
setPageDirection(i18n.language);

// Listen for language changes and update direction
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("i18nextLng", lng); // Save selected language
  setPageDirection(lng); // Update page direction
});

export default i18n;
